import { useDescribeHooks } from "../../../../../features/data-types"
import { Modal, ModalId } from "../../../../../features/ui"
import { TableName } from "../../../../../tables"
import { HoardOrder } from "../../../state/types"
import { useActions } from "./actions"

type Props = {
    hoard: HoardOrder
}

export const CancelHoardModal = (props: Props) => {
    const { hoard } = props

    const { describe } = useDescribeHooks()

    const { submitCancelHoard } = useActions()

    const onSubmit = () => submitCancelHoard(hoard.id)

    return (
        <Modal
            modalId={ModalId.CANCEL_HOARD}
            title="Cancelar Acopio?"
            submitLabel="Confirmar"
            submitKind="secondary"
            onSubmit={onSubmit}
        >
            <>Está por cancelar: <b>{describe(TableName.HOARD_ORDERS, hoard)}</b>. Dejará de aparecer en los listados y no se tendrá en cuenta para la cuenta corriente. Esta acción es irreversible.</>
        </Modal>
    )
}
